import { Context, Data, Effect, Layer } from 'effect';
export class FileReadError extends Data.TaggedError('@fixtuur/backpack/FileService/FileReadError') {
}
export class FileService extends Context.Tag('@fixtuur/backpack/Services/FileService')() {
}
export const LiveFileService = Layer.sync(FileService, () => {
    const toString = file => Effect.async(cb => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.result !== null) {
                cb(Effect.succeed(reader.result.toString()));
            }
            else {
                cb(Effect.fail(new FileReadError({ originalError: 'FileReader result is null' })));
            }
        };
        reader.onerror = err => {
            cb(Effect.fail(new FileReadError({ originalError: err })));
        };
        reader.readAsText(file);
    });
    return { toString };
});
